export default "__VITE_ASSET__CljAkyJa__"